import { all } from 'deepmerge';
import { PATH_TO_VARIANT } from '../../constants/path-to-variant.constant';
import { AppVariant } from '../../models/app-variant.enum';

export function mergeObject<T extends object = object>(...values: object[]): T {
  return all(values) as T;
}

export function detectVariantFromPath(
  /* istanbul ignore next */
  pathname = window.location.pathname,
): AppVariant {
  for (const [pattern, variant] of PATH_TO_VARIANT) {
    if (pattern.test(pathname)) return variant;
  }
  return AppVariant.GbSidedoor;
}
